"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HISTORICAL_PRICING_URL = exports.UDF_TRACK_REQUEST_MAX_DELAY = exports.UDF_MAX_REQUEST_COUNT = exports.DATAGRID_UDF_ENDPOINT = exports.DATAGRID_RDP_ENDPOINT = exports.DATAGRID_UDF_URL = exports.DATAGRID_RDP_URL = exports.DATAGRID_UDF_DATAPOINT_NAME = void 0;
exports.DATAGRID_UDF_DATAPOINT_NAME = 'DataGrid_StandardAsync';
exports.DATAGRID_RDP_URL = '/data/datagrid/beta1';
exports.DATAGRID_UDF_URL = '/api/udf';
exports.DATAGRID_RDP_ENDPOINT = '/standard';
exports.DATAGRID_UDF_ENDPOINT = '/';
exports.UDF_MAX_REQUEST_COUNT = 10;
exports.UDF_TRACK_REQUEST_MAX_DELAY = 15000;
exports.HISTORICAL_PRICING_URL = '/data/historical-pricing/v1';
